import type { FC } from 'react';

import { AccountNo } from '../account-no/AccountNo';
import type { BankConnection as BankConnectionType } from './BankConnectionService';
import { mapBankConnectionToAccount } from './BankConnectionService';

interface Props {
    bankConnection: BankConnectionType;
}

export const BankConnection: FC<Props> = ({ bankConnection }) => (
    <AccountNo account={mapBankConnectionToAccount(bankConnection)} />
);
